module.exports = __webpack_public_path__ + "static/media/security-check_7.6ab3a5d6.png";